import { BottomSheet } from 'react-spring-bottom-sheet';
import DialogHeader from './Header';
import useGlobalStyles from './styles';
import { Spaced } from '../Spaced/Spaced';
import 'react-spring-bottom-sheet/dist/style.css';
import Divider from '../Divider/Divider';

function Dialog({ onClose, show, children, title }: DialogProps) {
  useGlobalStyles();

  return (
    <BottomSheet onDismiss={onClose} open={show}>
      <Spaced>
        <DialogHeader title={title} onClose={onClose} />
      </Spaced>
      <Divider />
      {children}
    </BottomSheet>
  );
}

export default Dialog;
